module.exports = __webpack_public_path__ + "static/img/icon_drawer.eda7b26d.png";